module.exports = __webpack_public_path__ + "img/alert_stop.3380e5b5.png";